import React, { ReactNode } from 'react';
import { Tooltip } from '../../hoc';

export interface ButtonProps {
  variant?: ButtonVariant;
  size?: ButtonSize;
  children?: ReactNode;
  isDisabled?: boolean;
  tooltip?: Tooltip;
  isActive?: boolean;
  targetBlank?: boolean;
  onClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
  data?: Record<string, string>;
  href?: string;
  isInvert?: boolean;
  isFullWidth?: boolean;
}

export enum ButtonVariant {
  ELEVATED = 'elevated',
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
  TERTIARY = 'tertiary',
  LINK = 'link',
  PLAIN = 'plain',
  NEUTRAL = 'neutral',
  OUTLINE = 'outline',
  SOLID = 'solid',
  GHOST = 'ghost',
  DESTRUCTIVE = 'destructive',
}

export enum ButtonSize {
  COMPACT = 'compact',
  '2XS' = '2xs',
  XS = 'xs',
  SM = 'sm',
  MD = 'md',
  LG = 'lg',
}
